import { useEffect, useState } from 'react';
import styled from 'styled-components';

import { numberInputPaddingNorlys } from '~src/branding';
import { useDisplayContext } from '~src/context/DisplayContext';

import { FormElementWrapperNorlys, InputWrapper } from '../FormElementWrapper';
import { NumberInput as NumberInputCommon } from './common';
import { NumberInputProps } from './types';

export * from './types';

const CustomAddonAfter = styled.div({
  position: 'absolute',
  top: '50%',
  transform: 'translate(0, -50%)',
  right: '8px',
});

export const NumberInput = ({ label, attention, style, size = 'middle', ...rest }: NumberInputProps) => {
  const { isMobile } = useDisplayContext();
  return (
    <InputWrapper {...{ attention, label, style, size }}>
      <NumberInputCommon
        {...{
          size: isMobile ? 'middle' : size,
          ...rest,
        }}
      />
    </InputWrapper>
  );
};

export const StatefulNumberInput = ({ size = 'middle', value: inputValue, onChange, ...rest }: NumberInputProps) => {
  const { isMobile } = useDisplayContext();
  const [value, setValue] = useState<number | undefined>(inputValue as number);

  useEffect(() => setValue(inputValue as number), [inputValue]);

  return (
    <NumberInput
      {...{
        value,
        size: isMobile ? 'middle' : size,
        onChange: setValue,
        ...rest,
        onBlur: () => onChange(value),
      }}
    />
  );
};

export const NumberInputNorlys = ({
  label = 'Indtast nummer',
  attention,
  style,
  size = 'middle',
  addonAfter,
  ...rest
}: NumberInputProps) => {
  const { isMobile } = useDisplayContext();

  return (
    <FormElementWrapperNorlys {...{ attention, label, style, size }}>
      <NumberInputCommon
        {...{
          size,
          style: { paddingTop: numberInputPaddingNorlys(size), borderWidth: '2px' },
          addonAfter: isMobile ? addonAfter : undefined,
          ...rest,
        }}
      />

      {!!addonAfter && !isMobile && <CustomAddonAfter>{addonAfter}</CustomAddonAfter>}
    </FormElementWrapperNorlys>
  );
};
